const STATIC_INTERESTS_DATA_BY_MONTH = {
  5: [
    {
      segment: "Развлечения, Отдых, Хобби",
      reach: "801 641",
      transitions: "26 945",
      affinityIndex: "76,7",
      conversions: "1 651",
    },
    {
      segment: "Продукты, еда и напитки ",
      reach: "521 741",
      transitions: "19 208",
      affinityIndex: "152,79",
      conversions: "1 544",
    },
    {
      segment: "Канцелярские принадлежности",
      reach: "124 005",
      transitions: "4 594",
      affinityIndex: "127,59",
      conversions: "1 594",
    },
    {
      segment: "Отдых, туризм, путешествия",
      reach: "106 993",
      transitions: "4 711",
      affinityIndex: "80,55",
      conversions: "1 559",
    },
    {
      segment: "Техника для сельского хозяйства ",
      reach: "194 219",
      transitions: "6 368",
      affinityIndex: "136,62",
      conversions: "1 548",
    },
    {
      segment: "Собственность и недвижимость",
      reach: "93 214",
      transitions: "3 069",
      affinityIndex: "112,4",
      conversions: "845",
    },
    {
      segment: "Обустройство дома, ремонт",
      reach: "301 748",
      transitions: "9 410",
      affinityIndex: "125,92",
      conversions: "1 772",
    },
    {
      segment: "Бизнес, экономика, финансы",
      reach: "99 204",
      transitions: "3 978",
      affinityIndex: "90,75",
      conversions: "1 606",
    },
    {
      segment: "Техника и электроника",
      reach: "368 364",
      transitions: "11 390",
      affinityIndex: "144,69",
      conversions: "1 698",
    },
    {
      segment: "Связь, телефоны, интернет",
      reach: "259 874",
      transitions: "8 495",
      affinityIndex: "84,38",
      conversions: "907",
    },
  ],
  6: [
    {
      segment: "Продукты, еда и напитки",
      reach: "776 230",
      transitions: "15 695",
      affinityIndex: "142,88",
      conversions: "814",
    },
    {
      segment: "Техника для сельского хозяйства",
      reach: "362 108",
      transitions: "5 603",
      affinityIndex: "132,03",
      conversions: "607",
    },
    {
      segment: "Обустройство дома, ремонт",
      reach: "159 663",
      transitions: "7 630",
      affinityIndex: "127,75",
      conversions: "359",
    },
    {
      segment: "Техника и электроника",
      reach: "421 015",
      transitions: "12 104",
      affinityIndex: "123,54",
      conversions: "351",
    },
    {
      segment: "Профессиональный и любительский спорт",
      reach: "369 599",
      transitions: "8 416",
      affinityIndex: "113,35",
      conversions: "274",
    },
    {
      segment: "Собственность и недвижимость",
      reach: "158 747",
      transitions: "4 740",
      affinityIndex: "99,89",
      conversions: "468",
    },
    {
      segment: "Автомобили",
      reach: "599 621",
      transitions: "11 952",
      affinityIndex: "105,01",
      conversions: "511",
    },
    {
      segment: "Связь, телефоны, интернет",
      reach: "462 115",
      transitions: "9 653",
      affinityIndex: "88,69",
      conversions: "308",
    },
    {
      segment: "Канцелярские принадлежности",
      reach: "389 002",
      transitions: "7 466",
      affinityIndex: "96,3",
      conversions: "368",
    },
    {
      segment: "Товары для школьников",
      reach: "297 844",
      transitions: "2 652",
      affinityIndex: "96,3",
      conversions: "345",
    },
  ],
  7: [
    {
      segment: "Развлечения, Отдых, Хобби",
      reach: "1 098 104",
      transitions: "19 774",
      affinityIndex: "181,41",
      conversions: "204",
    },
    {
      segment: "Профессиональный и любительский спорт",
      reach: "385 431",
      transitions: "6 175",
      affinityIndex: "140,33",
      conversions: "162",
    },
    {
      segment: "Здоровье и фитнес",
      reach: "512 793",
      transitions: "12 370",
      affinityIndex: "137,57",
      conversions: "161",
    },
    {
      segment: "Обустройство дома, ремонт",
      reach: "436 331",
      transitions: "9 366",
      affinityIndex: "134,92",
      conversions: "184",
    },
    {
      segment: "Дом и сад",
      reach: "201 836",
      transitions: "4 097",
      affinityIndex: "112,1",
      conversions: "98",
    },
    {
      segment: "Собственность и недвижимость",
      reach: "398 410",
      transitions: "8 438",
      affinityIndex: "108,73",
      conversions: "173",
    },
    {
      segment: "Техника сельского хозяйства",
      reach: "184 116",
      transitions: "3 781",
      affinityIndex: "98,61",
      conversions: "90",
    },
    {
      segment: "Техника и электроника",
      reach: "349 521",
      transitions: "6 513",
      affinityIndex: "102,39",
      conversions: "106",
    },
    {
      segment: "Канцелярский принадлежности",
      reach: "424 745",
      transitions: "6 182",
      affinityIndex: "96,14",
      conversions: "97",
    },
    {
      segment: "Продукты, еда и напитки",
      reach: "584 822",
      transitions: "10 229",
      affinityIndex: "96,08",
      conversions: "134",
    },
  ],
  8: [
    {
      segment: "Развлечения и досуг",
      reach: "1 236 104",
      transitions: "9 607",
      affinityIndex: "139,41",
      conversions: "246",
    },
    {
      segment: "Спорт",
      reach: "947 366",
      transitions: "7 196",
      affinityIndex: "151,62",
      conversions: "207",
    },
    {
      segment: "Строительство, обустройство и ремонт",
      reach: "749 155",
      transitions: "5 941",
      affinityIndex: "140,39",
      conversions: "189",
    },
    {
      segment: "Бытовая техника",
      reach: "477 038",
      transitions: "3 520",
      affinityIndex: "113,74",
      conversions: "105",
    },
    {
      segment: "Техника и электроника",
      reach: "698 711",
      transitions: "4 932",
      affinityIndex: "109,73",
      conversions: "136",
    },
    {
      segment: "Транспорт",
      reach: "801 233",
      transitions: "7 238",
      affinityIndex: "123,49",
      conversions: "198",
    },
    {
      segment: "Автомобили",
      reach: "761 208",
      transitions: "6 107",
      affinityIndex: "122,07",
      conversions: "152",
    },
    {
      segment: "Собственность и недвижимость",
      reach: "1 611 430",
      transitions: "12 319",
      affinityIndex: "146,95",
      conversions: "387",
    },
    {
      segment: "Канцелярские принадлежности",
      reach: "364 779",
      transitions: "2 196",
      affinityIndex: "106,19",
      conversions: "84",
    },
    {
      segment: "Семья и дети",
      reach: "419 637",
      transitions: "3 516",
      affinityIndex: "97,90",
      conversions: "93",
    },
  ],
  9: [
    {
      segment: "Развлечения и досуг",
      reach: "1 639 841",
      transitions: "16 321",
      affinityIndex: "112,21",
      conversions: "348",
    },
    {
      segment: "Строительство, обустройство и ремонт",
      reach: "1 095 463",
      transitions: "14 399",
      affinityIndex: "189,42",
      conversions: "334",
    },
    {
      segment: "Бытовая техника",
      reach: "1 012 030",
      transitions: "14 760",
      affinityIndex: "174,33",
      conversions: "286",
    },
    {
      segment: "Спорт",
      reach: "859 495",
      transitions: "11 069",
      affinityIndex: "124,54",
      conversions: "243",
    },
    {
      segment: "Недвижимость",
      reach: "878 419",
      transitions: "7 032",
      affinityIndex: "136,94",
      conversions: "196",
    },
    {
      segment: "Собственность и недвижимость",
      reach: "621 339",
      transitions: "6 674",
      affinityIndex: "128,47",
      conversions: "209",
    },
    {
      segment: "Автомобили",
      reach: "329 151",
      transitions: "6 631",
      affinityIndex: "109,48",
      conversions: "120",
    },
    {
      segment: "Бизнес",
      reach: "485 737",
      transitions: "3 746",
      affinityIndex: "98,30",
      conversions: "91",
    },
    {
      segment: "Красота и здоровье",
      reach: "479 356",
      transitions: "8 417",
      affinityIndex: "111,36",
      conversions: "114",
    },
    {
      segment: "Семья и дети",
      reach: "465 100",
      transitions: "5 614",
      affinityIndex: "121,41",
      conversions: "142",
    },
  ],
};

export default STATIC_INTERESTS_DATA_BY_MONTH;
